import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import MuiAvatar from '@material-ui/core/Avatar'
import amber from '@material-ui/core/colors/amber'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'

import Storage from '../helpers/storage'


const SIZE = {
  small: 40,
  normal: 60,
}

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  avatar: {
    cursor: 'pointer',
    width: SIZE.small,
    height: SIZE.small,
  },
  description: {
    width: 'auto',
    height: '100%',
    marginRight: 15,
  },
  sizeNormal: {
    width: SIZE.normal,
    height: SIZE.normal,
  },
  progressPoints: {
    top: -6,
    left: -6,
    zIndex: 1,
    color: amber[300],
    position: 'absolute',
  },
})

class Avatar extends PureComponent {
  /* LIFECYCLE */
  state = {
    src: '',
    isLoading: false,
  }

  /**
   * @componentWillMount
   */
  componentWillMount() {
    const { imageUrl } = this.props

    if (imageUrl) {
      this.updateSrc(imageUrl)
    }
  }

  /**
   * @componentWillReceiveProps
   *
   * @param {*} nextProps - Next properties of the PureComponent
   */
  componentWillReceiveProps(nextProps) {
    const { imageUrl } = nextProps

    if (imageUrl && imageUrl !== this.props.imageUrl) {
      return this.updateSrc(imageUrl)
    }

    return null
  }


  /* METHODS */

  updateSrc = async (imageUrl) => {
    if (!imageUrl) {
      return this.setState({
        src: '',
        isLoading: false,
      })
    }

    this.setState({ isLoading: true })
    const src = await Storage.get(imageUrl)

    return this.setState({
      src,
      isLoading: false,
    })
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      size,
      classes,
      imageUrl,
      className,
      ...props
    } = this.props

    const {
      src,
      isLoading,
    } = this.state

    return (
      <div className={classes.root}>
        <MuiAvatar
          src={src}
          variant="rounded"
          className={classNames(classes.avatar, className, {
            [classes.sizeNormal]: size === 'normal',
          })}
          {...props}
        >
          {isLoading && <CircularProgress size={16} />}
        </MuiAvatar>
      </div>
    )
  }
}


Avatar.defaultProps = {
  imageUrl: '',
  size: 'normal',
}


Avatar.propTypes = {
  size: PropTypes.string,
  imageUrl: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(Avatar)
